import React from "react";
const dropShipping_wallet = ({
  isSelectedFather,
  isSingle = false,
  isHeader = false
}: {
  isSelectedFather?: Boolean;
  isSingle?: Boolean;
  isHeader?: Boolean;
}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={isHeader ? "#6266FF" : isSelectedFather ? isSingle ? "rgb(255,255,255)" : "url(#Gradient2)" : "rgb(12,23,42,0.8)"} width="16px" height="16px" data-sentry-element="svg" data-sentry-component="dropShipping_wallet" data-sentry-source-file="dropshipping_wallet.tsx">
      <path d="M16 12h2v4h-2z" data-sentry-element="path" data-sentry-source-file="dropshipping_wallet.tsx" />
      <path d="M20 7V5c0-1.103-.897-2-2-2H5C3.346 3 2 4.346 2 6v12c0 2.201 1.794 3 3 3h15c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zM5 5h13v2H5a1.001 1.001 0 0 1 0-2zm15 14H5.012C4.55 18.988 4 18.805 4 18V8.815c.314.113.647.185 1 .185h15v10z" data-sentry-element="path" data-sentry-source-file="dropshipping_wallet.tsx" />
    </svg>;
};
export default dropShipping_wallet;